// @Version: 1.0.1
export enum FC_AUTOCOMPLETE {
   VALUE = "value"
}

export enum TRANSLATE_SUFFIX {
   LABEL = 'Label',
   ERROR_NOT_ALLOWED = 'ErrorNotAllowed',
   ERROR_REQUIRED = 'ErrorRequired'
}

export interface IValidation {
   required: boolean; 
   notAllowed: boolean; 
}

export interface IDropDown {
   desc: string;
   key: string | number;
}